import { mode } from '@/helpers/enum';

export const initialData = () => ({
  currentStep: 0,
  isPledged: false,
  heir: {
    workAddress: {},
    residenceAddress: {},
    placeAddress: {},
    nationalAddress: {},
    nationalAddresses: [],
    contact: {},
    relatedPartiesInfo: [],
  },
  selectedCaseParty: {
    objectKey: null,
    partyType: null,
    casePartyRole: 0,
    isRetrievedFromMoi: false,
    isRetrievedFromMci: false,
    workAddress: {},
    residenceAddress: {},
    placeAddress: {},
    nationalAddress: {},
    nationalAddresses: [],
    contact: {},
    relatedPartiesInfo: [],
    subPartyRoleId: null,
  },
  submittedRequestInfo: { mode: mode.new },
  lawsuitRequest: {
    case: {
      laborContract: {},
      laborCaseRequests: [],
      evidences: [],
      custodyPeople: [],
      argumentPoints: [],
      forms: [],
      courtId: null,
      relatedCaseFormValue: [],

    },
    caseParties: [],
    attachments: [],
    requestAttachments: [],
    previousReplies: [],
    auditFields: {},
    caseTypesSearchResult: [],
    requiredAttachmentTypes: [],
    attachmentTypes: [],
    relatedCases: [],
  },
});

export default {
  currentStep: initialData().currentStep,
  isPledged: initialData().isPledged,
  subMode: null,
  selectedCaseParty: initialData().selectedCaseParty,
  submittedRequestInfo: initialData().submittedRequestInfo,
  lawsuitRequest: initialData().lawsuitRequest,
  contractLanguages: [],
  contractTypes: [],
  salaryPaymentIntervals: [],
  contractDropReasons: [],
  attachments: {
    data: {},
    viewAttachmentModal: {
      selectedAttachment: null,
      selectedAttachmentKey: null,
    },
    deleteAttachmentModal: {
      visibility: false,
      objectKey: null,
      attachmentKey: null,
    },
  },
  caseMovementReplyTypes: null,
  similarCases: {},
  similarRequests: {},
  similarReconciliationRequests: {},
  similarCasesModal: { visibility: null },
  replyModal: { visibility: null },
  relatedCases: {},
  flatDynamicFormsByName: {},
  originalData: {},
  activePartyAttributes: [], // صفات الاطراف
  partyAttributesBasicInfo: [], // معلومات أساسية عن صفات الأطراف
};
